import isFeatureEnabledLib from '@ahmdigital/logic/lib/utils/is-feature-enabled';

import config from '../../config';

const isFeatureEnabled = (feature: string) => isFeatureEnabledLib(config, feature);

export default isFeatureEnabled;
